// ===== FIREBASE & CACHE =====
let fdb=null;
let _persistenciaOffline='pendente';
async function configurarPersistenciaOffline(){
  if(!fdb||_persistenciaOffline==='ativa')return;
  try{await fdb.enablePersistence({synchronizeTabs:true});_persistenciaOffline='ativa'}
  catch(e){_persistenciaOffline=e?.code==='failed-precondition'?'outra-aba':'indisponivel';console.warn('Cache offline do Firestore:',e?.code||e)}
}

// ===== Logout seguro com limpeza de cache persistido (Fase 1) =====
// Dado sensível (confidencial/rh) pode ficar no cache offline do Firestore (IndexedDB) mesmo
// depois do logout, já que a persistência é ligada por instância, não por coleção. Este módulo
// garante que o cache local seja limpo de verdade no logout, coordenando entre abas abertas —
// só uma aba pode ter o IndexedDB aberto de cada vez, então todas precisam encerrar o Firestore
// antes de clearPersistence() funcionar.
const PESSOAS_RH_PENDING_KEY='gaturamo:clear-persistence-pending';
const _authChannel=typeof BroadcastChannel!=='undefined'?new BroadcastChannel('gaturamo-auth'):null;
const _tabId=(typeof uid==='function'?uid():`${Date.now()}-${Math.random().toString(36).slice(2)}`);
function pararListenersRealtime(){_realtimeUnsubs.forEach(fn=>{try{fn()}catch(e){}});_realtimeUnsubs=[]}
function limparCacheRhEmMemoria(){if(typeof DB!=='undefined'&&DB.limparCacheRh)DB.limparCacheRh()}
function mostrarTelaDeSeguranca(opts={}){
  const el=document.getElementById('security-lock-screen');if(!el)return;
  const t=document.getElementById('security-lock-titulo'),m=document.getElementById('security-lock-mensagem');
  if(t&&opts.titulo)t.textContent=opts.titulo;
  if(m&&opts.mensagem)m.textContent=opts.mensagem;
  document.getElementById('loading').style.display='none';
  document.getElementById('main').style.display='none';
  el.style.display='flex';
}
function mostrarTelaDeEncerramentoSeguro(){
  mostrarTelaDeSeguranca({titulo:'Encerrando sessão em outra aba',mensagem:'Esta aba será redirecionada automaticamente em instantes.'});
}
async function registrarErroSeguro(msg,e){console.error(msg,e)}
// Roda no boot, ANTES de enablePersistence()/listeners/qualquer leitura. Se uma aba foi
// suspensa/fechada no meio de um logout anterior sem concluir clearPersistence(), esta função
// resolve isso antes de deixar o app seguir com um cache local potencialmente sensível.
async function resolverLimpezaPendente(){
  if(!localStorage.getItem(PESSOAS_RH_PENDING_KEY))return true;
  try{
    await fdb.terminate();
    await fdb.clearPersistence();
    localStorage.removeItem(PESSOAS_RH_PENDING_KEY);
    return true;
  }catch(e){
    registrarErroSeguro('Não foi possível limpar o cache local pendente.',e);
    return false;   // marca NÃO é removida — não inicializa Firestore nem libera login
  }
}
async function logoutSeguro(){
  const requestId=_tabId+'-'+Date.now();
  localStorage.setItem(PESSOAS_RH_PENDING_KEY,'1');
  try{
    pararListenersRealtime();
    limparCacheRhEmMemoria();
    const acks=new Set();
    const aguardarAcks=_authChannel?new Promise(resolve=>{
      const handler=e=>{
        if(e.data?.type==='FIRESTORE_TERMINATED'&&e.data.requestId===requestId){
          acks.add(e.data.from);
          resolve();   // não temos como saber quantas abas existem de verdade — 1 ACK já é
                        // sinal de que pelo menos as abas visíveis reagiram; o timeout cobre o resto
        }
      };
      _authChannel.addEventListener('message',handler);
      setTimeout(resolve,2000);   // timeout — não trava o logout indefinidamente
    }):Promise.resolve();
    _authChannel?.postMessage({type:'PREPARE_SECURE_LOGOUT',requestId});
    await aguardarAcks;
    if(typeof firebase.auth==='function')await firebase.auth().signOut();
    await fdb.terminate();
    await fdb.clearPersistence();
    localStorage.removeItem(PESSOAS_RH_PENDING_KEY);
    _authChannel?.postMessage({type:'PERSISTENCE_CLEARED',requestId});
    location.reload();
  }catch(e){
    registrarErroSeguro('Falha ao limpar cache local no logout.',e);
    // PENDING_KEY continua gravado de propósito — não redireciona sozinho; fica bloqueado até
    // a limpeza resolver de fato (na próxima carga, via resolverLimpezaPendente()).
    mostrarTelaDeSeguranca({});
  }
}
if(_authChannel){
  _authChannel.onmessage=async e=>{
    if(e.data?.type==='PREPARE_SECURE_LOGOUT'){
      pararListenersRealtime();
      limparCacheRhEmMemoria();
      try{await fdb?.terminate()}catch(err){}
      _authChannel.postMessage({type:'FIRESTORE_TERMINATED',requestId:e.data.requestId,from:_tabId});
      // Não redireciona ainda — reabrir o Firestore nesta navegação antes da aba que iniciou o
      // logout terminar clearPersistence() travaria a limpeza dela.
      mostrarTelaDeEncerramentoSeguro();
    }
    if(e.data?.type==='PERSISTENCE_CLEARED'){
      location.reload();
    }
  };
}
// Em modo SaaS multiempresa, NUNCA cair para a coleção global/raiz: se o módulo
// MarmoriaSaaS não carregou (falha de script, bloqueio, etc.), bloquear a operação
// em vez de gravar/ler dados fora do contexto do tenant ativo (risco de mistura
// entre empresas). Modo legado single-tenant (MARMORARIA_SAAS_MODE!==true) mantém
// o comportamento original, sem tenant, por design.
function appCollection(name){
  if(window.MARMORARIA_SAAS_MODE===true){
    if(!window.MarmoriaSaaS?.collection)throw new Error('TENANT_CONTEXT_REQUIRED: módulo multiempresa não carregado — operação bloqueada.');
    return window.MarmoriaSaaS.collection(fdb,name);
  }
  return fdb.collection(name);
}
function appConfigDoc(){
  if(window.MARMORARIA_SAAS_MODE===true){
    if(!window.MarmoriaSaaS?.configDoc)throw new Error('TENANT_CONTEXT_REQUIRED: módulo multiempresa não carregado — operação bloqueada.');
    return window.MarmoriaSaaS.configDoc(fdb);
  }
  return fdb.collection('config').doc('main');
}
function exigirPermissaoColecao(name,action='write'){if(window.MARMORARIA_SAAS_MODE===true&&!window.MarmoriaSaaS?.canCollection(name,action)){toast('Seu perfil não possui permissão para esta operação.','error');throw new Error(`PERMISSION_DENIED:${name}:${action}`)}}
const APP_COLLECTIONS=Object.freeze(['pedidos','orcamentos','orcamento_versoes','orcamento_aceites','contratos','contrato_versoes','contrato_eventos','obras','lancamentos','recebiveis','pagamentos','plano_pagamento','notas_fiscais','notas_tomadas','contas_bancarias','integracoes_logs','support_tickets','internal_support','platform_support_tickets','leads','tarefas','rotinas','ordens','estoque','chapas','retalhos','reservas_estoque','fornecedores','pedras','acabamentosEspeciais','compras','compras_futuras','compras_realizados','precos_fornecedor','clientes','cliente_contatos','enderecos','medicoes','medicoes_versoes','projetos','pecas_tecnicas','modelos_tecnicos','planos_corte','juridico','contratos_prestadores','maquinas','manutencoes','custos_producao','pessoas','avaliacoes','recomendacao_decisoes','chat_mensagens','notificacoes','documentos','auditoria','snapshots']);
const CACHE=Object.fromEntries(APP_COLLECTIONS.map(k=>[k,[]]));
CACHE.config={};
const PLATAFORMA_IDENTIDADE=window.GaturamoIdentity?.getPlatformIdentity?.()||{name:'Gaturamo Gestão para Marmorarias',commercialName:'Gaturamo',logoUrl:'./assets/logo-gaturamo.svg'};
const CONTRATO_RODAPE_PLATAFORMA='Documento gerado pela plataforma Digital Gaturamo Gestão para Marmorarias.';
const TENANT_TESTE_PADRAO=window.GaturamoIdentity?.DEFAULT_TEST_ORGANIZATION||{id:'marmoraria-bom-sucesso',nomeFantasia:'Marmoraria Bom Sucesso',cnpj:'38.008.878/0001-46',tipoConta:'teste',ambiente:'homologacao'};
const EMPRESA_NOME_PADRAO=TENANT_TESTE_PADRAO.nomeFantasia;
const EMPRESA_DOCUMENTO_NAO_CONFIGURADA='Empresa usuária não configurada';
const EMPRESA_LOGO_PADRAO=window.GaturamoIdentity?.DEFAULT_TENANT_BRAND?.logoUrl||'./assets/logo-bom-sucesso.png';
function normalizarNomeEmpresa(nome){return String(nome||'').trim()}
function normalizarLogoEmpresa(url){const u=String(url||'').trim();return u||EMPRESA_LOGO_PADRAO;}
function organizacaoAtiva(){return window.GaturamoIdentity?.getActiveOrganization?.(window.MarmoriaSaaS?.state||{})||TENANT_TESTE_PADRAO}
function nomeOrganizacaoAtiva(org=organizacaoAtiva()){return normalizarNomeEmpresa(org.nomeFantasia||org.name||org.organizationName||EMPRESA_NOME_PADRAO)}
function configEmpresaNormalizada(cfg={}){const org=organizacaoAtiva();const base=window.GaturamoIdentity?.getTenantIdentity?.(org.id,{organization:org,config:cfg})||{...cfg,nome:cfg.nome||org.nomeFantasia||EMPRESA_NOME_PADRAO,cnpj:cfg.cnpj||org.cnpj||'',logoUrl:cfg.logoUrl||EMPRESA_LOGO_PADRAO};return{...cfg,...base,nome:normalizarNomeEmpresa(base.nome||base.nomeFantasia),logoUrl:normalizarLogoEmpresa(base.logoUrl)}}
// Quadrante de identidade no cabeçalho: nome da empresa (tenant) + filial.
// Não existe ainda um campo de filial próprio no cadastro (cfg.filial/
// cfg.unidade) além do filtro de unidade já usado no dashboard
// (dashboardOverviewUnits, ligado a pedidos, não à empresa em si) — até essa
// modelagem existir, mostramos "Matriz" como padrão seguro de local único,
// em vez de inventar um nome de filial.
function atualizarQuadranteEmpresa(cfg={}){
  const wrap=document.getElementById('tb-tenant-info'),nameEl=document.getElementById('tb-tenant-name'),branchEl=document.getElementById('tb-tenant-branch');
  if(!wrap||!nameEl||!branchEl)return;
  if(!cfg.nome){wrap.hidden=true;return}
  nameEl.textContent=cfg.nome;
  branchEl.textContent=cfg.filial||cfg.unidade||'Matriz';
  wrap.hidden=false;
}
function identidadeDocumentoTenant(cfg=CACHE.config||{}){const org=organizacaoAtiva();return window.GaturamoIdentity?.getTenantDocumentIdentity?.(org.id,{organization:org,config:configEmpresaNormalizada(cfg),platformVersion:typeof APP_BUILD!=='undefined'?APP_BUILD:''})||{displayName:configEmpresaNormalizada(cfg).nome||EMPRESA_DOCUMENTO_NAO_CONFIGURADA,logoUrl:normalizarLogoEmpresa(cfg.logoUrl),tenantSnapshot:{},platformReference:{name:PLATAFORMA_IDENTIDADE.name,generatedByPlatform:true}}}
function rgLegadoValor(obj={}){return obj?.legacyRg?.value||obj?.rg||''}
function normalizarRgLegado(valor,origem='legado'){
  const value=String(valor||'').trim();
  return value?{value,legacy:true,source:'rg',origin:origem}:null;
}
function preservarRgLegado(target,valor,origem='legado'){
  const legado=normalizarRgLegado(valor,origem);
  if(legado&&!target.legacyRg)target.legacyRg=legado;
  delete target.rg;
  return target;
}
function nomeEmpresaDocumento(cfg={}){const doc=identidadeDocumentoTenant(cfg);return doc.displayName||doc.nomeFantasia||EMPRESA_DOCUMENTO_NAO_CONFIGURADA;}
function validarListaColecao(k,v,origem='DB.set'){
  if(!Array.isArray(v))throw new TypeError(`${origem}(${k}) espera uma lista completa da coleção, recebeu ${Object.prototype.toString.call(v)}.`);
  v.forEach((item,i)=>{if(!item||typeof item!=='object'||Array.isArray(item))throw new TypeError(`${origem}(${k}) recebeu item inválido na posição ${i}.`);if(!item.id)throw new TypeError(`${origem}(${k}) exige id no item da posição ${i}.`);});
}
function validarCommitColecoes(sets){
  if(!Array.isArray(sets))throw new TypeError('DB.commit espera uma lista de operações [{key,value}].');
  sets.forEach((entry,i)=>{if(!entry||typeof entry!=='object'||Array.isArray(entry))throw new TypeError(`DB.commit recebeu operação inválida na posição ${i}.`);if(!entry.key)throw new TypeError(`DB.commit exige key na operação ${i}.`);validarListaColecao(entry.key,entry.value,'DB.commit');});
}
const PHONE_FIELDS_BY_COLLECTION=Object.freeze({leads:['tel'],clientes:['tel'],pedidos:['tel'],fornecedores:['tel'],pessoas:['tel','tel2']});
function enriquecerTelefoneRegistro(collection,item){
  const fields=PHONE_FIELDS_BY_COLLECTION[collection]||[];
  fields.forEach(field=>{if(item?.[field])item[field+'Info']=window.PhoneIntelligence?.metadata(item[field])||null;else if(item)delete item[field+'Info']});
  return item;
}
// ===== v350: Controle de concorrência otimista (_version) + invariantes de integridade =====
// Regra: nunca "última gravação vence" silenciosamente em registros críticos.
// Cada gravação em coleção versionada incrementa _version; salvar um item cuja
// _version é menor que a vigente no cache sincronizado indica edição concorrente → bloqueia.
const DB_VERSIONED=new Set(['clientes','pedidos','contratos','medicoes','estoque','recebiveis','pagamentos','lancamentos','ordens','compras','pecas_tecnicas','modelos_tecnicos','retalhos','planos_corte','contrato_eventos','juridico']);
// Tombstones: ids excluídos conhecidos (via DB.remove local ou sumiço no realtime).
// Permitem distinguir RECRIAÇÃO de registro excluído (bloquear) de CLONE legítimo
// de um registro existente com novo id (permitir, zerando a _version herdada).
const _DB_TOMBSTONES={};
function _registrarTombstone(k,id){if(!k||!id)return;(_DB_TOMBSTONES[k]=_DB_TOMBSTONES[k]||new Set()).add(id)}
class ConflitoVersaoError extends Error{constructor(msg,detalhe){super(msg);this.name='ConflitoVersaoError';this.conflito=true;this.detalhe=detalhe||null}}
function _rotuloRegistro(item){return item?.nome||item?.cliente||item?.desc||item?.numero||item?.num||item?.id||'registro'}
function verificarVersaoEIntegridade(k,changed,prevById,origem='DB.set'){
  for(const item of changed){
    const atual=prevById.get(item.id);
    if(DB_VERSIONED.has(k)){
      const vNovo=Number(item._version)||0,vAtual=Number(atual?._version)||0;
      if(atual&&vNovo<vAtual){
        const msg=`Conflito de edição em "${_rotuloRegistro(item)}": o registro foi alterado por outro usuário enquanto você editava. Recarregue, confira as alterações e salve novamente.`;
        toast(msg,'error');throw new ConflitoVersaoError(msg,{colecao:k,id:item.id,versaoEnviada:vNovo,versaoAtual:vAtual,origem});
      }
      if(!atual){
        if(vNovo>0&&_DB_TOMBSTONES[k]&&_DB_TOMBSTONES[k].has(item.id)){
          const msg=`O registro "${_rotuloRegistro(item)}" foi excluído por outro usuário e não será recriado automaticamente.`;
          toast(msg,'error');throw new ConflitoVersaoError(msg,{colecao:k,id:item.id,excluidoPorOutro:true,origem});
        }
        item._version=0; // registro novo ou clone legítimo: garante _version numérica (nunca undefined) antes do batch.set
      }
    }
    if(k==='contratos'&&atual&&atual.status==='assinado'){
      const camposImutaveis=['conteudo','valor','clienteId','pedidoId','cliente'];
      const alterou=camposImutaveis.filter(c=>JSON.stringify(item[c]??null)!==JSON.stringify(atual[c]??null));
      if(alterou.length&&!item._aditivoId){
        const msg=`Contrato assinado é imutável (campos alterados: ${alterou.join(', ')}). Registre um ADITIVO para formalizar a mudança.`;
        toast(msg,'error');throw new ConflitoVersaoError(msg,{colecao:k,id:item.id,camposAlterados:alterou,origem});
      }
    }
    if(k==='estoque'&&(Number(item.totalDisponivel)<0||(item.chapas||[]).some(c=>Number(c.m2)<0||Number(c.largura)<0||Number(c.altura)<0))){
      const msg=`Estoque de "${_rotuloRegistro(item)}" ficaria NEGATIVO. Operação bloqueada — confira reservas e baixas.`;
      toast(msg,'error');throw new ConflitoVersaoError(msg,{colecao:k,id:item.id,estoqueNegativo:true,origem});
    }
    if((k==='recebiveis'||k==='pagamentos'||k==='lancamentos')&&Number(item.valor)<0){
      const msg='Valor financeiro negativo não é permitido. Para estorno, exclua o lançamento vinculado (a reversão dos vínculos é automática).';
      toast(msg,'error');throw new ConflitoVersaoError(msg,{colecao:k,id:item.id,valorNegativo:true,origem});
    }
  }
}
// Consultoria/gestão é preço que o tenant paga à Gaturamo por um serviço contratado — o tenant
// nunca deve conseguir alterar esses campos em config, seja pelo formulário, restauração de
// padrões ou importação de backup. DB.setObj é o único caminho de escrita de 'config' (ver uso
// abaixo), então a proteção fica centralizada ali em vez de espalhada por cada chamador.
const CAMPOS_CONSULTORIA_PROTEGIDOS=['consultoriaAtiva','consultor','consultorBase','consultorPct','consultoriaAtualizadaEm','consultoriaAtualizadaPor'];
function omitirCamposConsultoria(obj={}){const c={...obj};CAMPOS_CONSULTORIA_PROTEGIDOS.forEach(k=>delete c[k]);return c}
function selecionarCamposConsultoria(obj={}){const s={};CAMPOS_CONSULTORIA_PROTEGIDOS.forEach(k=>{if(Object.prototype.hasOwnProperty.call(obj,k))s[k]=obj[k]});return s}
const DB={
  list:k=>JSON.parse(JSON.stringify(CACHE[k]||[])),
  get:k=>DB.list(k),
  getById:(k,id)=>DB.list(k).find(item=>item.id===id)||null,
  getObj:(k,d={})=>JSON.parse(JSON.stringify(CACHE[k]||d)),
  async set(k,v){
    validarListaColecao(k,v,'DB.set');
    if(!fdb)throw new Error('Banco de dados desconectado. Recarregue a aplicação.');
    exigirPermissaoColecao(k,'write');
    const prev=JSON.parse(JSON.stringify(CACHE[k]||[]));
    // Grava somente registros realmente alterados. Exclusões são sempre explícitas
    // em DB.remove(), evitando que uma lista desatualizada apague dados de outro usuário.
    const prevById=new Map(prev.map(item=>[item.id,item]));
    const changed=v.filter(item=>item?.id&&JSON.stringify(prevById.get(item.id)||null)!==JSON.stringify(item));
    changed.forEach(item=>enriquecerTelefoneRegistro(k,item));
    if(changed.length>450)throw new Error('Muitas alterações simultâneas. Divida a operação em blocos menores.');
    // v350: bloqueio otimista + invariantes ANTES de qualquer mutação local
    verificarVersaoEIntegridade(k,changed,prevById,'DB.set');
    CACHE[k]=v;setSync(true);
    try{
      if(changed.length){
        // Injetar metadados de auditoria em cada item alterado
        const now=new Date().toISOString();
        const _u=typeof firebase.auth==='function'?firebase.auth().currentUser:null;
        const _support=window.MarmoriaSaaS?.state.contextMode==='support'?window.MarmoriaSaaS.state.supportSession:null;
        const _by=_support?.operatorCode||_u?.email||_u?.uid||'sistema';
        changed.forEach(item=>{
          if(!prevById.has(item.id)){item.createdAt=item.createdAt||now;item.createdBy=item.createdBy||_by;}
          item.updatedAt=now;item.updatedBy=_by;
          if(_support){item.supportTicketId=_support.ticketId;item.supportTicketNumber=_support.ticketNumber;item.supportSessionId=_support.id;}
          if(DB_VERSIONED.has(k))item._version=(Number(prevById.get(item.id)?._version)||0)+1;
        });
        // Firestore recebe serverTimestamp para updatedAt (mais preciso); CACHE fica com ISO string
        const batch=fdb.batch();
        changed.forEach(item=>batch.set(appCollection(k).doc(item.id),{...item,updatedAt:firebase.firestore.FieldValue.serverTimestamp()},{merge:true}));
        await batch.commit();
      }
    }catch(e){CACHE[k]=prev;console.error('DB.set error',k,e);toast('Falha ao salvar. Verifique a conexão.','error');throw e}
    finally{setSync(false)}
  },
  async remove(k,id){
    if(!fdb)throw new Error('Banco de dados desconectado. Recarregue a aplicação.');
    exigirPermissaoColecao(k,'write');
    const prev=JSON.parse(JSON.stringify(CACHE[k]||[]));
    const esperado=prev.find(item=>item.id===id)||null;
    CACHE[k]=prev.filter(item=>item.id!==id);setSync(true);
    _registrarTombstone(k,id);
    try{
      const ref=appCollection(k).doc(id);
      if(DB_VERSIONED.has(k)&&esperado){
        await fdb.runTransaction(async tx=>{
          const snap=await tx.get(ref);
          if(!snap.exists)return;
          const versaoServidor=Number(snap.data()?._version)||0,versaoEsperada=Number(esperado._version)||0;
          if(versaoServidor!==versaoEsperada){
            throw new ConflitoVersaoError(`O registro "${_rotuloRegistro(esperado)}" foi alterado por outro usuário e não pode ser excluído sem revisão. Recarregue os dados e tente novamente.`,{colecao:k,id,versaoEsperada,versaoServidor,origem:'DB.remove'});
          }
          tx.delete(ref);
        });
      }else await ref.delete();
    }
    catch(e){CACHE[k]=prev;console.error('DB.remove error',k,e);toast(e?.conflito?e.message:'Falha ao excluir. Verifique a conexão.',e?.conflito?'error':'error');throw e}
    finally{setSync(false)}
  },
  async insert(k,item){
    if(!item||typeof item!=='object'||Array.isArray(item))throw new TypeError('DB.insert espera um objeto.');
    if(!item.id)throw new TypeError('DB.insert exige id.');
    const lista=DB.get(k);
    if(lista.some(x=>x.id===item.id))throw new Error(`Registro já existe em ${k}: ${item.id}`);
    lista.unshift(item);
    await DB.set(k,lista);
    return item;
  },
  async update(k,id,patch){
    if(!patch||typeof patch!=='object'||Array.isArray(patch))throw new TypeError('DB.update espera um objeto de alterações.');
    const lista=DB.get(k),idx=lista.findIndex(x=>x.id===id);
    if(idx<0)throw new Error(`Registro não encontrado em ${k}: ${id}`);
    lista[idx]={...lista[idx],...patch,id};
    await DB.set(k,lista);
    return lista[idx];
  },
  async upsert(k,item){
    if(!item||typeof item!=='object'||Array.isArray(item))throw new TypeError('DB.upsert espera um objeto.');
    if(!item.id)throw new TypeError('DB.upsert exige id.');
    const lista=DB.get(k),idx=lista.findIndex(x=>x.id===item.id);
    if(idx>=0)lista[idx]={...lista[idx],...item};else lista.unshift(item);
    await DB.set(k,lista);
    return item;
  },
  createImmutableVersion(collection,item,extra={}){
    if(!item||typeof item!=='object'||Array.isArray(item))throw new TypeError('createImmutableVersion espera um objeto.');
    const now=new Date().toISOString();
    return Object.freeze(JSON.parse(JSON.stringify({...item,...extra,id:extra.id||`${collection}_versao_${item.id||uid()}_${Date.now()}`,sourceCollection:collection,sourceId:item.id||'',version:extra.version||item.version||1,immutable:true,createdAt:now,updatedAt:now})));
  },
  async setObj(k,v){
    if(!fdb)throw new Error('Banco de dados desconectado. Recarregue a aplicação.');
    if(window.MARMORARIA_SAAS_MODE===true&&!window.MarmoriaSaaS?.can('admin')){toast('Somente administradores alteram as configurações da empresa.','error');throw new Error('PERMISSION_DENIED:config')}
    const prev=CACHE[k]||{};
    const next=k==='config'?{...omitirCamposConsultoria(v),...selecionarCamposConsultoria(prev)}:v;
    CACHE[k]=next;setSync(true);
    try{
      if(k==='config')await appConfigDoc().set(omitirCamposConsultoria(next),{merge:true});
      else await appConfigDoc().set(next);
    }
    catch(e){CACHE[k]=prev;console.error(e);toast('Falha ao salvar configurações.','error');throw e}
    finally{setSync(false)}
  },
  async commit(sets){
    validarCommitColecoes(sets);
    if(!fdb)throw new Error('Banco de dados desconectado. Recarregue a aplicação.');
    if(!sets.length)return;
    const anteriores={};const operacoes=[];
    for(const entry of sets){const k=entry.key,v=entry.value;exigirPermissaoColecao(k,'write');anteriores[k]=JSON.parse(JSON.stringify(CACHE[k]||[]));const prevById=new Map(anteriores[k].map(item=>[item.id,item]));v.filter(item=>item?.id&&JSON.stringify(prevById.get(item.id)||null)!==JSON.stringify(item)).forEach(item=>operacoes.push({k,item:enriquecerTelefoneRegistro(k,item)}));}
    if(operacoes.length>450)throw new Error('Muitas alterações simultâneas. Divida a operação em blocos menores.');
    // v350: bloqueio otimista + invariantes por coleção antes do commit atômico
    for(const entry of sets){const k=entry.key;const prevById=new Map((anteriores[k]||[]).map(item=>[item.id,item]));verificarVersaoEIntegridade(k,operacoes.filter(o=>o.k===k).map(o=>o.item),prevById,'DB.commit')}
    setSync(true);
    try{
      const now=new Date().toISOString();
      const _u=typeof firebase.auth==='function'?firebase.auth().currentUser:null;
      const _support=window.MarmoriaSaaS?.state.contextMode==='support'?window.MarmoriaSaaS.state.supportSession:null;
      const _by=_support?.operatorCode||_u?.email||_u?.uid||'sistema';
      // Injetar metadados antes do commit atômico
      operacoes.forEach(({k,item})=>{
        const prev=anteriores[k]||[];
        const isNew=!prev.find(p=>p.id===item.id);
        if(isNew){item.createdAt=item.createdAt||now;item.createdBy=item.createdBy||_by;}
        item.updatedAt=now;item.updatedBy=_by;
        if(_support){item.supportTicketId=_support.ticketId;item.supportTicketNumber=_support.ticketNumber;item.supportSessionId=_support.id;}
      });
      const batch=fdb.batch();operacoes.forEach(({k,item})=>batch.set(appCollection(k).doc(item.id),{...item,updatedAt:firebase.firestore.FieldValue.serverTimestamp()},{merge:true}));await batch.commit();sets.forEach(entry=>CACHE[entry.key]=entry.value)}
    catch(e){Object.entries(anteriores).forEach(([k,v])=>CACHE[k]=v);console.error('DB.commit error',e);toast('Nenhuma alteração foi aplicada. Verifique a conexão.','error');throw e}
    finally{setSync(false)}
  },
  // ===== Restrição real de dados sensíveis de pessoas (Fase 1) =====
  // Só chamar para papéis com acesso a RH (owner/admin/hr) — ver salvarPessoa() em
  // pessoasSalvarPessoaRh(). Grava o documento público de pessoas/{id} e a subcoleção
  // confidencial/rh na mesma transação. Distingue criação de atualização porque a regra do
  // Firestore exige metadados diferentes em cada caso (ver firestore.rules).
  async savePessoaComRh(dadosPublicos,form){
    if(!fdb)throw new Error('Banco de dados desconectado. Recarregue a aplicação.');
    if(!navigator.onLine)throw new Error('É necessário estar conectado para salvar dados bancários ou de remuneração.');
    exigirPermissaoColecao('pessoas','write');
    const uidAtual=typeof firebase.auth==='function'?firebase.auth().currentUser?.uid:null;
    if(!uidAtual)throw new Error('Usuário não autenticado.');
    const pubRef=appCollection('pessoas').doc(dadosPublicos.id);
    const rhRef=pubRef.collection('confidencial').doc('rh');
    const now=firebase.firestore.FieldValue.serverTimestamp();
    const pixPreenchido=!!(form&&form.pix&&(form.pix.chave||form.pix.tipo&&form.pix.tipo!=='sem_pix'));
    const bancoPreenchido=!!(form&&form.dadosBancarios&&(form.dadosBancarios.agencia||form.dadosBancarios.conta));
    const dadosRhCriacao={createdAt:now,updatedAt:now,updatedBy:uidAtual,schemaVersion:1};
    if(pixPreenchido)dadosRhCriacao.pix=form.pix;
    if(bancoPreenchido)dadosRhCriacao.dadosBancarios=form.dadosBancarios;
    // Baseado no payload sanitizado de verdade, não em dois booleans soltos — assim um
    // futuro campo de salário/benefício não passa despercebido nesta checagem.
    const temAlgumDadoRh=Object.keys(dadosRhCriacao).some(k=>!['createdAt','updatedAt','updatedBy','schemaVersion'].includes(k));
    const patchRhAtualizacao={
      pix:pixPreenchido?form.pix:firebase.firestore.FieldValue.delete(),
      dadosBancarios:bancoPreenchido?form.dadosBancarios:firebase.firestore.FieldValue.delete(),
      updatedAt:now,updatedBy:uidAtual
    };
    await fdb.runTransaction(async tx=>{
      const rhSnap=await tx.get(rhRef);
      tx.set(pubRef,{...dadosPublicos,updatedAt:now},{merge:true});
      if(!rhSnap.exists){
        if(temAlgumDadoRh)tx.set(rhRef,dadosRhCriacao);
      }else{
        tx.update(rhRef,patchRhAtualizacao);
      }
    });
    // A transação já confirmou — o salvamento está garantido a partir daqui. A releitura
    // abaixo é só para atualizar o cache local; se ela falhar, isso NÃO significa que o
    // salvamento falhou.
    try{
      // {source:'server'} força ir ao servidor — com persistência offline ligada, um
      // .get() comum poderia responder do cache local desatualizado.
      const[pubSnap,rhSnap2]=await Promise.all([pubRef.get({source:'server'}),rhRef.get({source:'server'})]);
      DB._atualizarCachePessoa(pubSnap.id,pubSnap.data());
      if(rhSnap2.exists)DB._atualizarCacheRh(pubSnap.id,rhSnap2.data());
      else DB._removerCacheRh(pubSnap.id);
    }catch(e){
      DB._invalidarCachePessoa(dadosPublicos.id);
      console.warn('Pessoa salva, mas falhou ao atualizar cache local',e);
    }
  },
  // Papel sem acesso a RH: grava só o documento público, nunca lê nem toca confidencial/rh.
  async savePessoaPublica(dadosPublicos){
    if(!fdb)throw new Error('Banco de dados desconectado. Recarregue a aplicação.');
    exigirPermissaoColecao('pessoas','write');
    const pubRef=appCollection('pessoas').doc(dadosPublicos.id);
    await pubRef.set({...dadosPublicos,updatedAt:firebase.firestore.FieldValue.serverTimestamp()},{merge:true});
    try{
      const pubSnap=await pubRef.get({source:'server'});
      DB._atualizarCachePessoa(pubSnap.id,pubSnap.data());
    }catch(e){
      DB._invalidarCachePessoa(dadosPublicos.id);
      console.warn('Pessoa salva, mas falhou ao atualizar cache local',e);
    }
  },
  _atualizarCachePessoa(id,data){
    const lista=CACHE.pessoas||(CACHE.pessoas=[]);
    const idx=lista.findIndex(p=>p.id===id);
    const item={...data,id};
    if(idx>=0)lista[idx]=item;else lista.unshift(item);
  },
  _invalidarCachePessoa(id){
    // O gravamento no Firestore já confirmou (esta função só roda quando a releitura pós-commit
    // falha) — não vale corromper CACHE.pessoas com um sentinela (null/undefined): dezenas de
    // outras funções iteram esse array assumindo que todo item é um objeto válido. 'pessoas' não
    // está na lista de coleções com listener em tempo real, então o pior caso é a lista mostrar
    // o valor anterior (levemente desatualizado) até o próximo carregamento — aceitável, já que
    // isso é só uma falha ao atualizar o cache local, não uma falha de gravação.
    console.warn('Cache de pessoa possivelmente desatualizado até o próximo carregamento:',id);
  },
  _atualizarCacheRh(pessoaId,data){
    if(!CACHE._pessoasRh)CACHE._pessoasRh={};
    CACHE._pessoasRh[pessoaId]={...data,_status:'ok'};
  },
  _removerCacheRh(pessoaId){
    if(!CACHE._pessoasRh)CACHE._pessoasRh={};
    CACHE._pessoasRh[pessoaId]={_status:'nao_informado'};
  },
  limparCacheRh(){CACHE._pessoasRh={}}
};
window.SettingsCenterRuntime={
  getPlatformName:()=>PLATAFORMA_IDENTIDADE.name,
  getConfig:()=>CACHE.config||{},
  get:key=>DB.get(key),
  insert:(key,item)=>DB.insert(key,item),
  setObj:(key,value)=>DB.setObj(key,value)
};

let _realtimeUnsubs=[];
let _realtimeRenderTimer=null;
function renderActivePageFromSync(){
  clearTimeout(_realtimeRenderTimer);
  _realtimeRenderTimer=setTimeout(()=>{
    const page=document.querySelector('.page.active')?.id?.replace('page-','');
    if(page&&document.getElementById('main')?.style.display!=='none')PAGE_RENDER[page]?.();
    updateBadges();
  },120);
}
function iniciarRealtime(){
  _realtimeUnsubs.forEach(fn=>fn());_realtimeUnsubs=[];
  const cols=APP_COLLECTIONS.filter(col=>!['auditoria','snapshots'].includes(col));
  cols.filter(col=>window.MARMORARIA_SAAS_MODE!==true||window.MarmoriaSaaS?.canCollection(col,'read')).forEach(col=>_realtimeUnsubs.push(appCollection(col).onSnapshot(s=>{
    // v350: registra tombstones de documentos que sumiram do snapshot (excluídos por outra sessão)
    const _idsAtuais=new Set(s.docs.map(d=>d.id));
    (CACHE[col]||[]).forEach(item=>{if(item?.id&&!_idsAtuais.has(item.id))_registrarTombstone(col,item.id)});
    CACHE[col]=s.docs.map(d=>({...d.data(),id:d.id}));renderActivePageFromSync();
  },e=>console.error('Sincronização',col,e))));
  _realtimeUnsubs.push(appConfigDoc().onSnapshot(d=>{CACHE.config=d.exists?d.data():{};}));
  if(window.MARMORARIA_SAAS_MODE!==true||window.MarmoriaSaaS?.can('admin'))_realtimeUnsubs.push(appCollection('auditoria').orderBy('timestamp','desc').limit(200).onSnapshot(s=>{
    CACHE.auditoria=s.docs.map(d=>({...d.data(),id:d.id}));
    if(histTab==='audit')renderAuditoria();
  }));
}

